import { useTranslation } from 'react-i18next';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TestimonialsSection = () => {
  const { t } = useTranslation();

const testimonials = [
    {
      id: 1,
      name: 'Marco Bernini',
      role: 'CEO, TechItalia S.r.l.',
      avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1094b6670-1763301032314.png",
      avatarAlt: 'Ritratto professionale uomo',
      content: 'OrizonDesk ha eliminato totalmente il cartaceo nella nostra azienda. La distribuzione delle buste paga ora avviene in pochi secondi con la massima sicurezza GDPR.',
      rating: 5
    },
    {
  
  id: 2,
  name: 'Amra Hadžić',
  role: 'HR menadžer, Digitalne Inovacije',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15f7af3b7-1763297493149.png",
  avatarAlt: 'Profesionalni portret žene',
  content: 'Konačno naši uposlenici mogu pristupiti svojim ugovorima i dokumentima gdje god se nalazili. Nevjerovatna ušteda vremena za HR sektor i cijelu administraciju.',
  rating: 5
},
    {
      id: 3,
      name: 'Alessandro Santoro',
      role: 'Responsabile IT, FinanzaSecure',
      avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17d2ee875-1763293294582.png",
      avatarAlt: 'Ritratto professionale uomo',
      content: 'La crittografia end-to-end garantisce che i documenti sensibili siano protetti. È la piattaforma più affidabile per la conservazione digitale che abbiamo testato.',
      rating: 5
    },
     {
      id: 6,
      name: 'Kenan Hodžić',
      role: 'Vlasnik, Balkan Trade Group',
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=150&h=150",
      avatarAlt: 'Profesionalni portret muškarca',
      content: 'Napokon imamo rješenje koje eliminira fascikle. Digitalne platne liste i sigurna arhiva dokumenata su nam uštedjeli sate administrativnog posla.',
      rating: 5
    },
    {
      id: 4,
      name: 'Elena Moretti',
      role: 'Amministratrice, Studio Legale Moretti',
      avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&h=150",
      avatarAlt: 'Ritratto professionale donna',
      content: 'Il passaggio alla documentazione digitale è stato immediato. I dipendenti hanno apprezzato la facilità con cui scaricano le buste paga dal portale.',
      rating: 5
    },
    {
      id: 5,
      name: 'James Wilson',
      role: 'Operations Director, Global Logistics Ltd',
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&h=150",
      avatarAlt: 'Professional man portrait',
      content: 'Managing pay slips and digital records for our international team has never been easier. OrizonDesk is the perfect tool for digital transformation.',
      rating: 5
    },
   
  ];

  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-12 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4 lg:mb-5">
            {t('testimonials.title')}
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            {t('testimonials.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7 lg:gap-8">
          {testimonials?.map((testimonial) => (
            <div
              key={testimonial?.id}
              className="bg-card rounded-xl p-6 md:p-7 lg:p-8 border border-border shadow-elevation-1 hover:shadow-elevation-2 transition-all duration-250"
            >
              <div className="flex items-center gap-4 mb-5 md:mb-6">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full overflow-hidden flex-shrink-0 border-2 border-primary/20">
                  <Image
                    src={testimonial?.avatar}
                    alt={testimonial?.avatarAlt}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base md:text-lg font-semibold text-foreground truncate">
                    {testimonial?.name}
                  </h3>
                  <p className="text-sm md:text-base text-muted-foreground truncate">
                    {testimonial?.role}
                  </p>
                </div>
              </div>

              <div className="flex gap-1 mb-4 md:mb-5">
                {[...Array(testimonial?.rating)]?.map((_, index) => (
                  <Icon
                    key={index}
                    name="Star"
                    size={16}
                    color="var(--color-warning)"
                    className="fill-current"
                  />
                ))}
              </div>

              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                "{testimonial?.content}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;